<template>
    <!-- 版本列表 -->
    <div class="box-main">
      <div class="main">
        <div>
          <div class="main-title">版本列表</div>
          <div class="main-title-tips">可对软件升级版本信息进行查看和修改</div>
        </div>
        <div class="main-center">
          <v-button class="v-icon-add" v-permission="'upgrade:version:add'"  type="primary" name="" @click="showAddNewVersion()">发布新版本</v-button>
          <!-- <v-button type="info" name="" v-permission="'upgrade:version:sync'" @click="synchronization">全量同步</v-button> -->
          <span class="visontips" v-permission="'upgrade:version:add'">提示：发布新版本时，可选中某一版本作为上一个版本！</span>
          <v-input
              class="inputsearch"
              v-model="searchValue"
              placeholder="请输入搜索内容"
              suffix-icon="v-icon-search"
              @change="searchdata"
        ></v-input>
        </div>
        <div>
          <vxe-table
              border
              row-id="id"
              ref="xTable"
              :data="table"
              @radio-change = checkMethod
              align="left"
              @cell-click="cellClickEvent"
              :row-style="setRowClass"
            >
              <vxe-table-column type="radio" width="70" title="请选择"></vxe-table-column>
              <vxe-table-column field="id" show-overflow min-width="40" title="ID"></vxe-table-column>
              <vxe-table-column field="product_name" show-overflow min-width="120" title="所属产品"></vxe-table-column>
              <vxe-table-column field="product_key" show-overflow min-width="150" title="产品KEY"></vxe-table-column>
              <vxe-table-column field="software_version" show-overflow min-width="250" title="软件版本"></vxe-table-column>
              <vxe-table-column field="version_typeshow" show-overflow min-width="80" title="版本类型"></vxe-table-column>
              <vxe-table-column field="created_at" show-overflow min-width="120"  title="发布日期"></vxe-table-column>
              <vxe-column title="操作" min-width="180">
                <template v-slot="slotProps">
                  <span class="handle-button"><v-button size="S" type="text" name="btn1" slot="reference" @click="showEdit(slotProps.row)">编辑</v-button></span>
                  <span class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="showDown(slotProps.row)">下载</v-button></span>
                  <span class="handle-button"><v-button size="S" type="text" name="btn3" slot="reference" @click="showDel(slotProps.row)">删除</v-button></span>
                  <span class="handle-button"><v-button size="S" type="text" name="btn4" slot="reference" @click="showDetails(slotProps.row)">详情</v-button></span>
                  <span class="handle-button"><v-button size="S" type="text" name="btn5" slot="reference" @click="showChain(slotProps.row)">版本链</v-button></span>
                </template>
              </vxe-column>
            </vxe-table>
        </div>
        <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage" ></v-pagination>
      </div>
        <Down :showInputDialog.sync="Downloading" ref="Down" :UseId="showID" :file_url="dowmfile_url"></Down>
        <Del :showInputDialog.sync="Delloading" ref="Del" :UseId="showID" :model="model" :software_version="software_version" @getData="getData()"></Del>
        <Details :showInputDialog="Detailsloading" v-if="detailshow" ref="Details" :row="rows" @getData="getData()" @change="showDetails"></Details>
        <Edit :showInputDialog="Editloading" ref="Edit" v-if="edshow" :row="row" @getData="getData()" @change="showEdit"></Edit>
        <AddNewVersion :showInputDialog.sync="AddNewVersionloading" :fatherVison="fatherVison" :fatherProduct="fatherProduct" :fatherSoftware="fatherSoftware" :fatherVersion_type="fatherVersion_type" ref="AddNewVersion"  @getData="getData()"></AddNewVersion>
        <VersionChain :showAddDialog.sync="tanchuloading" :chainproductName="chainproductName" :chainSoftware_version="chainSoftware_version" :chainId="chainId" ref="tan" @change="showChain"></VersionChain>
    </div>
</template>
<script>
import Down from "@/components/version-list/down.vue";
import Del from "@/components/version-list/del.vue";
import Edit from "@/components/version-list/edit.vue";
import Details from "@/components/version-list/details.vue";
import AddNewVersion from "@/components/version-list/add-new-version.vue";
import VersionChain from "@/components/version-list/version-chain.vue";
export default {
  components: { Down,Del,Edit,AddNewVersion,Details ,VersionChain},
  data() {
    return {
      search:'',
      Downloading:false,
      Delloading:false,
      Editloading:false,
      Detailsloading:false,
      AddNewVersionloading:false,
      tanchuloading:false,
      showID:"",
      model:'',
      searchValue:'',
      software_version:'',
      chainId:'',
      row:{},
      rows:{},
      edshow:false,
      detailshow:false,
      dowmfile_url:'',
      currentPage: 1,
      pageSize: 10,
      searchData:'',
      chainSoftware_version:'',
      chainproductName:'',
      table: [],
      fatherVison:'',
      fatherProduct:'',
      fatherSoftware: '',
      fatherVersion_type: '',
      total: 0
    };
  },
  created() {
    this.getData()
  },
  methods: {
    //点击 利用刷新页面取消选中 || 打开详情页面
    cellClickEvent({row ,column}){
      row.checkedNum = row.checkedNum + 1
      if(this.fatherVison){
        if(row.checkedNum != 1){
          this.getData()
        }else{
          return
        }
      }else if(column.title == '操作'){
        return
      }else{
        this.showDetails(row)
      }

    },
    //选中某行 将此行的版本数据传给要新建的版本
    checkMethod({row}){
      row.checkedNum = 0
      this.fatherVison = row.id
      this.fatherProduct = row.product_name
      this.fatherSoftware = row.software_version
      this.fatherVersion_type = row.version_type
    },
    setRowClass({rowIndex}){
     if( rowIndex%2!==0){
        return "background: #fafafa";
     }
    },
    //搜索转换
    searchAll(){
      this.searchData = this.search
      if("正式版本".indexOf(this.search) != -1){ this.searchData = 'release' }
      if("测试版本".indexOf(this.search) != -1){ this.searchData = 'beta' }
      if(this.search == ''){this.searchData = ''}
      this.search = this.searchData
    },
    async getData(){
      const subData = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        search: this.search,
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/firmware/list/v1",
        subData
      );
      if(res.code === 0){
        this.table = res.data.list
        this.total = res.data.page_result.total
        this.table.forEach((item)=>{
          item.version_typeshow = item.version_type == 'release' ? '正式版本' : '测试版本'
          item.disabled_cloudshow = item.disabled_cloud == '0' ? '禁用' : '不禁用'
        })
      }else{
        if(res.code == '100410'){
          setTimeout(() => {
            this.getData()
          },1000)
        }else{
          this.$message.error(res.msg);
        }
      }
      //页面刷新 父版本清空 取消单选选中
      this.fatherVison = ''
      this.fatherProduct = ''
      this.fatherSoftware = ''
      this.fatherVersion_type = ''
    },
    searchdata(){
      this.currentPage = 1
      this.search = this.searchValue
      this.searchAll()
      this.getData()
    },
    changePage(page){
        this.currentPage = page
        this.getData()
    },
    changeSize(size){
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    //下载
    showDown(row){
      this.Downloading = !this.Downloading
      if(this.Downloading == true){
        this.showID = row.id
        this.dowmfile_url = row.file_url
      }
    },
    //删除
    showDel(row){
      this.Delloading = !this.Delloading
      if(this.Delloading == true){
        this.showID = row.id
        this.model = row.product_name
        this.software_version = row.software_version
      }
    },
    //编辑
    showEdit(row){
      this.Editloading = !this.Editloading
      if(this.Editloading == true){
        this.row = row
      }
      this.edshow = true
    },
    //详情
    showDetails(row){
      this.Detailsloading = !this.Detailsloading
      if(this.Detailsloading == true){
        this.rows = row
      }
      this.detailshow = true
    },
    //添加新版本
    showAddNewVersion(){
      this.AddNewVersionloading = !this.AddNewVersionloading
      if(!this.AddNewVersionloading){
        this.fatherVison = ''
        this.fatherProduct = ''
        this.fatherSoftware = ''
        this.fatherVersion_type = ''
      }
    },
    //版本链
    showChain(row){
      this.tanchuloading = !this.tanchuloading
      if(this.tanchuloading == true){
        this.chainId = row.id
        this.chainproductName = row.product_name
        this.chainSoftware_version = row.software_version
      }
    },
  },
};
</script>
<style lang="scss">
</style>